import React from 'react';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import NavbarDefault from "./components/navbarDefault";
import FooterDefault from "./components/footerDefault";
import { CardActionArea, createTheme, responsiveFontSizes } from '@mui/material';
import Box from '@mui/material/Box';

import dcs_banner from './images/aech.webp';

import ticket_icon from './images/ticket_icon.png';
import link_icon from './images/link_icon.png';
import qa_icon from './images/qa_icon.png';
import faq_icon from './images/info_icon.png';


import { ThemeProvider } from '@emotion/react';

let theme = createTheme({
  typography: {
    fontFamily: [
      'Segoe UI', 
      'sans-serif',
    ].join(','),
  }
});

theme = responsiveFontSizes(theme);

function Home() {
  const bannerStyle = { width: "100%", maxHeight: "40vh", minHeight: "100px", objectFit: "cover", objectPosition: "center", filter: "brightness(0.6)" };
  const bannerText = { color: "white", position: "absolute", top: "60%", left: "30%", transform: "translate(-50%, -50%)", textAlign: "left" };
  const cardIcon = { float:"right", opacity:"40%" };
  const gridStyle1 = { flexGrow: 1, paddingBottom: 2, paddingRight: 2, marginTop: 2, marginLeft: "auto", marginRight: "auto", maxWidth: 1, alignItems: "center" };
  const gridStyle2 = {flexGrow: 1, paddingBottom: 2, paddingRight: 2, marginBottom: 2, marginLeft: "auto", marginRight: "auto", maxWidth: 1, alignItems: "center" };

  const cardStyle = { width: 1, height: "100%", boxShadow: 5, minHeight: "100%", maxWidth: "900px" };

  const buttonStyle = { ":hover": {bgcolor: "#5A0C0E", color:"white"}, bgcolor:"#223730" };

  return (
    <ThemeProvider theme={theme}>

      {/* NAVIGATION BAR */}
      <NavbarDefault />

      {/* PAGE BANNER */}
      <div style={{position: 'relative', textAlign: 'center'}}>

        {/* BANNER IMAGE */}
        <img src={dcs_banner} style={bannerStyle} alt="Department of Computer Science Banner"/>

        {/* BANNER TEXT */}
        <Typography gutterBottom variant="h3" marginLeft={5} style={bannerText}>
          <b> WELCOME! <br/>
            <Typography variant="h5">
              HOW CAN WE HELP YOU?
            </Typography> 
          </b>
        </Typography>
      </div>

      {/* INSTANTIATE GRID ROW 1*/}
      <Grid container direction="row" justifyContent="center" height="50%" spacing={2} sx={gridStyle1}>

        {/* UPPER LEFT - SUBMIT A TICKET */}
        <Grid item xs={12} sm={12} md={7} lg={4}>
          <Card sx={cardStyle}>
            <CardActionArea>

              {/* TICKET ICON */}
              <img src={ticket_icon} style={cardIcon} alt="Ticket Icon"/>

              {/* TEXT */}
              <CardContent>
                <Typography gutterBottom variant="h4" component="div" marginTop={15} marginLeft={3}>
                  <b>SUBMIT A TICKET</b>
                </Typography>
                <Typography variant="h6" color="text.secondary" marginLeft={3}>
                  Got any questions/concerns?
                </Typography>
                <Box display="flex" justifyContent="space-between" marginLeft={3} marginTop={2} marginBottom={5}>
                  <Button variant="contained" size="large" href="/OpenTicket" sx={buttonStyle}>
                    CREATE TICKET
                  </Button>
                </Box>
              </CardContent>

            </CardActionArea>
          </Card>
        </Grid>

        {/* UPPER RIGHT - DCS WEBSITE */}
        <Grid item xs={12} sm={12} md={7} lg={4}>
          <Card sx={cardStyle}>
            <CardActionArea>

              {/* LINK ICON */}
              <img src={link_icon} style={cardIcon} alt="Link Icon"/>

              {/* TEXT */}
              <CardContent>
                <Typography gutterBottom variant="h4" component="div" marginTop={15} marginLeft={3}>
                  <b>DCS WEBSITE</b>
                </Typography>
                <Typography variant="h6" color="text.secondary" marginLeft={3}>
                  View the Department's website.
                </Typography>
                <Box display="flex" justifyContent="space-between" marginLeft={3} marginTop={2} marginBottom={5}>
                  <Button variant="contained" size="large" href="https://dcs.upd.edu.ph/" sx={buttonStyle}>
                    VISIT WEBSITE
                  </Button>
                </Box>
              </CardContent>

            </CardActionArea>
          </Card>
        </Grid>
      </Grid>

      {/* INSTANTIATE GRID ROW 2*/}
      <Grid container direction="row" justifyContent="center" spacing={2} sx={gridStyle2}>

        {/* LOWER LEFT - TICKET STATUS */}
        <Grid item xs={12} sm={12} md={7} lg={4}>
          <Card sx={cardStyle}>
            <CardActionArea>

              {/* QUESTION MARK ICON */}
              <img src={qa_icon} style={cardIcon} alt="Question Mark Icon"/>

              {/* TEXT */}
              <CardContent>
                <Typography gutterBottom variant="h4" component="div" marginTop={15} marginLeft={3}>
                  <b>TICKET STATUS</b>
                </Typography>
                <Typography variant="h6" color="text.secondary" marginLeft={3}>
                  Follow-up on previous tickets.
                </Typography>
                <Box display="flex" justifyContent="space-between" marginLeft={3} marginTop={2} marginBottom={5}>
                  <Button variant="contained" size="large" href="/CheckTicket" sx={buttonStyle}>
                    CHECK TICKET
                  </Button>
                </Box>
              </CardContent>

            </CardActionArea>
          </Card>
        </Grid>

        {/* LOWER RIGHT - FAQs */}
        <Grid item xs={12} sm={12} md={7} lg={4}>
          <Card sx={cardStyle}>
            <CardActionArea>

              {/* INFORMATION ICON */}
              <img src={faq_icon} style={cardIcon} alt="Information Icon"/>

              {/* TEXT */}
              <CardContent>
                <Typography gutterBottom variant="h4" component="div" marginTop={15} marginLeft={3}>
                  <b>FAQs</b>
                </Typography>
                <Typography variant="h6" color="text.secondary" marginLeft={3}>
                  Check frequently asked questions.
                </Typography>
                <Box display="flex" justifyContent="space-between" marginLeft={3} marginTop={2} marginBottom={5}>
                  <Button variant="contained" size="large" href="/FAQs" sx={buttonStyle}>
                    Visit FAQs
                  </Button>
                </Box>
              </CardContent>

            </CardActionArea>
          </Card>
        </Grid>
      </Grid>

      {/* FOOTER IMAGE ATTRIBUTION */}
      <div style={{padding: "20px"}}>
        <Typography fontSize="9px"  style={{ textAlign: "center" }}>
          Image Attribution: <a href="https://commons.wikimedia.org/wiki/File:UP_Alumni_Engineers_Centennial_Hall.JPG" style={{color: "black"}}>Engglib</a>, <a href="https://creativecommons.org/licenses/by-sa/3.0" style={{color: "black"}}>CC BY-SA 3.0</a>, via Wikimedia Commons
        </Typography>
      </div>

      {/* FOOTER NAVIGATION */}
      <FooterDefault />

    </ThemeProvider>
  )
}

export default Home